import { render, staticRenderFns } from "./receipt-add-or-update.vue?vue&type=template&id=43dd0818&scoped=true"
import script from "./receipt-add-or-update.vue?vue&type=script&lang=js"
export * from "./receipt-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./receipt-add-or-update.vue?vue&type=style&index=0&id=43dd0818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd0818",
  null
  
)

export default component.exports